/*

  ______  _____   ______ _______  ______
 |_____/ |     | |  ____ |______ |_____/
 |    \_ |_____| |_____| |______ |    \_

 vehicle sales system

(c) 2006 - 2019 TCE <TCE-ITDevelopers@toyota-ce.com>

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

import * as moment from 'moment';

(function () {
    "use strict";

    angular
        .module("ROGER")

        //
        .controller("ShoppingCartController", [
            "$scope", "$http", "$sessionStorage", "$uibModal", "$shoppingCart", "$messageBox", "$q", "$location", "$user", "$oidc", "$notifications", "$translate",
            function ($scope, $http, $sessionStorage, $uibModal, $shoppingCart, $messageBox, $q, $location, user, oidc, notifications, translate) {
                $scope.$storage = $sessionStorage;

                $scope.salesOrder = {
                    invoiceToId: $scope.$storage.retailer.InvoiceToId,
                    invoiceToName: $scope.$storage.retailer.InvoiceToDisplayName,
                    deliverToId: $scope.$storage.retailer.Id,
                    deliverToName: $scope.$storage.retailer.DisplayName,
                    orderedById: $scope.$storage.user.Id,
                    orderedByName: user.name,
                    orderLines: $scope.$storage.shoppingCart
                };

                $scope.retailers = [];
                $scope.salesOrderTypes = [];
                $scope.countries = [];
                $scope.lastSalesOrderNumber = "";

                // Order types
                $scope.loadOrderTypes = function () {
                    return $http
                        .get("/api/sales-order-type", {
                            params: {
                                retailerId: $scope.$storage.retailer.Id
                            },
                            headers: {
                                Authorization: oidc.current.token_type + " " + oidc.current.access_token
                            }
                        })
                        .then(function (response) {
                            $scope.orderTypes = response.data;
                        });
                };

                // Retailers
                $scope.loadRetailers = function () {
                    return $http
                        .get("/api/retailer", {
                            headers: {
                                Authorization: oidc.current.token_type + " " + oidc.current.access_token
                            }
                        }).then(function (response) {
                            $scope.retailers = response.data;
                        });
                };

                // Countries
                $scope.loadCountries = function () {
                    return $http
                        .get("/api/country", {
                            headers: {
                                Authorization: oidc.current.token_type + " " + oidc.current.access_token
                            }
                        })
                        .then(function (response) {
                            $scope.countries = response.data;
                        });
                };

                $scope.getCountryIdByIsoShort = function (isoShort) {
                    for (var index = 0; index < $scope.countries.length; index++) {
                        if ($scope.countries[index].IsoShort === isoShort) {
                            return $scope.countries[index].Id;
                        }
                    }
                    return -1;
                };

                $scope.getModelColor = function (itemData) {
                    return itemData.ModelColorName + ' [' + itemData.InteriorColor + ', ' + itemData.ExteriorColor + ']';
                }

                // Survey
                $scope.brandModelLineLookup = function (searchText) {
                    return $http
                        .get("api/sales-survey/brand-model-line/search", {
                            params: {
                                searchText: searchText
                            },
                            headers: {
                                Authorization: oidc.current.token_type + " " + oidc.current.access_token
                            }
                        })
                        .then(function (response) {
                            return response.data;
                        });
                };

                // Last sales order number
                $scope.loadLastOrderNumber = function () {
                    return $http
                        .get("/api/retailer/" + $scope.$storage.retailer.Id + "/sales-order/last-number", {
                            headers: {
                                Authorization: oidc.current.token_type + " " + oidc.current.access_token
                            }
                        })
                        .then(function (response) {
                            $scope.lastSalesOrderNumber = new String(response.data).replace("\"", "");
                        });
                };

                // Suggest new sales order number
                $scope.suggestSalesOrderNumber = function () {
                    var result = new String($scope.lastSalesOrderNumber);

                    var currentYear = moment().year();
                    var previousYear = moment().subtract(1, "year").year();
                    var currentMonth = moment().month();
                    var previousMonth = moment().subtract(1, "month").month();

                    var numericParts = result.match(/\d+/g);

                    var yearPartIndex = null;
                    var monthPartIndex = null;
                    var sequencePartIndex = null;

                    var resetSequencePart = false;

                    // parse and suggest sequence and date parts
                    var part;
                    var number;
                    if (typeof numericParts != "undefined" && numericParts != null) {
                        for (var numericPartIndex = 0; numericPartIndex < numericParts.length; numericPartIndex++) {
                            part = numericParts[numericPartIndex];
                            number = Number(part);
                            if (part.length === 4 && (number === currentYear || number === previousYear)) {
                                yearPartIndex = numericPartIndex;
                            } else if (part.length === 2 && (number === currentMonth || number === previousMonth)) {
                                monthPartIndex = numericPartIndex;
                            } else {
                                sequencePartIndex = numericPartIndex;
                            }
                        }
                    } else {
                        result = result + 1;
                    }

                    // recheck parts if no sequence part
                    if (sequencePartIndex == null) {
                        if (yearPartIndex != null && monthPartIndex != null) {
                            sequencePartIndex = monthPartIndex;
                            monthPartIndex = null;
                        } else if (yearPartIndex != null && monthPartIndex == null) {
                            sequencePartIndex = yearPartIndex;
                            yearPartIndex = null;
                        }
                    }

                    // update year part
                    var newPart;
                    if (yearPartIndex != null) {
                        part = numericParts[yearPartIndex];
                        number = Number(part);
                        if (number === previousYear) {
                            newPart = ("0000000000000000" + currentYear.toString());
                            result = result.replace(part, newPart.substring(newPart.length - part.length));
                            resetSequencePart = true;
                        }
                    }

                    // update month part
                    if (monthPartIndex != null) {
                        part = numericParts[monthPartIndex];
                        number = Number(part);
                        if (number === previousMonth) {
                            newPart = ("0000000000000000" + currentMonth.toString());
                            result = result.replace(part, newPart.substring(newPart.length - part.length));
                            resetSequencePart = true;
                        }
                    }

                    // update sequence part
                    if (sequencePartIndex != null) {
                        part = numericParts[sequencePartIndex];
                        number = Number(part);
                        if (resetSequencePart) {
                            number = 1;
                        } else {
                            number = number + 1;
                        }
                        newPart = ("0000000000000000" + number.toString());
                        result = result.replace(part, newPart.substring(newPart.length - part.length));
                    }

                    $scope.$storage.shoppingCart.number = result;
                };

                $scope.getLastSalesOrderNumber = function () {
                    $scope.$storage.shoppingCart.number = $scope.lastSalesOrderNumber;
                };

                // Empty shopping cart
                $scope.empty = function () {
                    $messageBox.showConfirm("EmptyShoppingCart", "EmptyShoppingCartConfirmation", "EmptyShoppingCart")
                        .result
                        .then(function () {
                            $shoppingCart.empty();
                            $location.path("/sales-orders");
                        }, function () { });
                };

                // Create sales order
                $scope.getSalesOrder = function () {
                    var result = {
                        Id: null,
                        Number: $scope.$storage.shoppingCart.number,
                        InvoiceToId: $scope.salesOrder.invoiceToId,
                        DeliverToId: $scope.salesOrder.deliverToId,
                        CreatedById: $scope.salesOrder.orderedById,
                        Lines: []
                    };

                    for (var index = 0; index < $scope.salesOrder.orderLines.length; index++) {
                        var line = {
                            Id: null,
                            Order: index + 1,
                            TypeId: $scope.salesOrder.orderLines[index].orderType,
                            ReservationId: $scope.salesOrder.orderLines[index].type === "Reservation" ? $scope.salesOrder.orderLines[index].data.Id : null,
                            ModelColorId: $scope.salesOrder.orderLines[index].data.ModelColorId,
                            CampaignId: $scope.salesOrder.orderLines[index].campaign,
                            FleetModelId: $scope.salesOrder.orderLines[index].fleetModel,
                            CustomerName: $scope.salesOrder.orderLines[index].CustomerName,
                            CustomerCountryId: $scope.salesOrder.orderLines[index].CustomerCountryId,
                            Note: $scope.salesOrder.orderLines[index].note,
                            UnitId: $scope.salesOrder.orderLines[index].type === "Bonus" ? $scope.salesOrder.orderLines[index].data.UnitId : null,
                            PostCode: $scope.isHungaryCcpOrExp($scope.salesOrder.orderLines[index].CustomerCountryId, $scope.salesOrder.orderLines[index].orderType) ? $scope.salesOrder.orderLines[index].postCode : null,
                            PostProductionOptionsIds: [],
                            Email: $scope.salesOrder.orderLines[index].email,
                            FromSolId: $scope.isFromOtherSalesOrder($scope.salesOrder.orderLines[index]) ? $scope.salesOrder.orderLines[index].fromSalesOrder.OrderLineId : null
                        };

                        for (var index1 = 0; index1 < $scope.salesOrder.orderLines[index].postProductionOptions.length; index1++) {
                            if ($scope.salesOrder.orderLines[index].postProductionOptions[index1].IsChecked) {
                                line.PostProductionOptionsIds.push($scope.salesOrder.orderLines[index].postProductionOptions[index1].Id);
                            }
                        }

                        result.Lines.push(line);
                    }

                    return result;
                };

                $scope.isFromOtherSalesOrder = function (item) {
                    return item.hasOwnProperty("fromSalesOrder");
                }

                $scope.checkFleets = function () {
                    var deferred = $q.defer();

                    deferred.resolve();

                    //for (var index = 0; index < $scope.salesOrder.orderLines.length; index++) {
                    //    if ($scope.salesOrder.orderLines[index].campaigns.length > 0 &&
                    //    (
                    //        typeof $scope.salesOrder.orderLines[index].campaign == "undefined" ||
                    //            $scope.salesOrder.orderLines[index].campaign == null
                    //    )) {
                    //        existsNonselectedCampaign = true;
                    //        break;
                    //    }
                    //}

                    return deferred.promise;
                };

                $scope.isCcp = function (orderTypeId) {
                    if (!$scope.orderTypes)
                        return false;

                    for (var i = 0; i < $scope.orderTypes.length; i++) {
                        if (orderTypeId === $scope.orderTypes[i].Id
                            && $scope.orderTypes[i].Code === "CCP") {
                            return true;
                        }
                    }
                    return false;
                }

                $scope.isExp = function (orderTypeId) {
                    if (!$scope.orderTypes)
                        return false;

                    for (var i = 0; i < $scope.orderTypes.length; i++) {
                        if (orderTypeId === $scope.orderTypes[i].Id
                            && $scope.orderTypes[i].Code === "EXP") {
                            return true;
                        }
                    }
                    return false;
                }
                
                $scope.isHungary = function (countryId) {
                    if (!$scope.countries)
                        return false;

                    for (var i = 0; i < $scope.countries.length; i++) {
                        if ($scope.countries[i].Id === countryId
                            && $scope.countries[i].IsoShort === "HU") {
                            return true;
                        }
                    }
                    return false;
                }

                $scope.isHungaryCcpOrExp = function (countryId, orderTypeId) {
                    return $scope.isHungary(countryId) && ($scope.isCcp(orderTypeId) || $scope.isExp(orderTypeId));
                }

                $scope.campaignExists = function (retailerId, modelColorId, orderType, fleetModel, unitId, solFromResId) {
                    return $http
                        .get("/api/campaign", {
                            params: {
                                retailerId: retailerId,
                                modelColorId: modelColorId,
                                salesOrderTypeId: orderType,
                                fleetModelId: fleetModel,
                                unitId: unitId,
                                solFromResId: solFromResId
                            },
                            headers: {
                                Authorization: oidc.current.token_type + " " + oidc.current.access_token
                            }
                        })
                        .then(function (response) {
                            var campaigns = response.data;
                            if (campaigns.length > 0) {
                                return true;
                            }
                            return false;
                        });
                };

                $scope.checkNotSelectedCampaigns = function () {
                    var deferred = $q.defer();

                    var promises = [];

                    var salesOrder = $scope.getSalesOrder();
                    var lines = salesOrder.Lines;

                    for (var i = 0; i < lines.length; i++) {
                        if ((lines[i].type != "Bonus" || lines[i].type.OtherDiscounts) && (lines[i].CampaignId == null || lines[i].CampaignId == "undefined" || lines[i].CampaignId == -1)) {
                            promises.push($scope.campaignExists($scope.$storage.retailer.Id, lines[i].ModelColorId, lines[i].TypeId, lines[i].FleetModelId, lines[i].UnitId, lines[i].ReservationId));
                        }
                    }

                    $q.all(promises).then(function (data) {
                        var exists = false;
                        for (var i = 0; i < data.length; i++) {
                            if (data[i] === true) {
                                exists = true;
                                break;
                            }
                        }

                        if (exists) {
                            $messageBox
                                .showConfirm("Campaign", "NoCampaignSelected", "CreateSalesOrder")
                                .result
                                .then(function () {
                                    deferred.resolve();
                                }, function () {
                                    deferred.reject();
                                });
                        }
                        else {
                            deferred.resolve();
                        }
                    });

                    return deferred.promise;
                }

                $scope.checkCampaigns = function () {
                    var deferred = $q.defer();

                    var existsNonselectedCampaign = false;
                    for (var index = 0; index < $scope.salesOrder.orderLines.length; index++) {
                        if (typeof $scope.salesOrder.orderLines[index].campaigns != "undefined") {
                            if ($scope.salesOrder.orderLines[index].campaigns.length > 0 &&
                                (
                                    typeof $scope.salesOrder.orderLines[index].campaign == "undefined" ||
                                    $scope.salesOrder.orderLines[index].campaign == null
                                )) {
                                existsNonselectedCampaign = true;
                                break;
                            }
                        }
                    }
                    if (existsNonselectedCampaign) {
                        $messageBox
                            .showConfirm("CreateSalesOrder", "CreateSalesOrderConfirmation", "CreateSalesOrder")
                            .result
                            .then(function () {
                                deferred.resolve();
                            }, function () {
                                deferred.reject();
                            });
                    } else {
                        deferred.resolve();
                    }

                    return deferred.promise;
                };

                $scope.createSalesOrder = function () {
                    return $scope
                        .checkCampaigns()
                        .then(function () {
                            return $scope.checkNotSelectedCampaigns();
                        })
                        .then(function () {
                            return $messageBox
                                .showConfirm("CreateSalesOrder", "CreateSalesOrderConfirmation", "CreateSalesOrder")
                                .result
                                .then(function () {
                                    return $http
                                        .post("/api/retailer/" + $scope.$storage.retailer.Id + "/sales-order", $scope.getSalesOrder(), {
                                            headers: {
                                                Authorization: oidc.current.token_type + " " + oidc.current.access_token
                                            }
                                        })
                                        .then(function () {
                                            $shoppingCart.empty();
                                            $scope.$storage.number = null;
                                            $location.path("/sales-orders");
                                            return $q.resolve();
                                        }, function (rejection) {
                                            if (rejection.data.Code === 'AllocationFailed') {
                                                $shoppingCart.empty();
                                                $scope.$storage.number = null;
                                                $location.path("/sales-orders");
                                                return $q.resolve();
                                            }

                                            return $q.reject(rejection);
                                        });
                                }, function () { });
                        });
                };

                // On load
                $scope.loadLastOrderNumber()
                    .then(function () {
                        if (typeof $scope.$storage.shoppingCart.number == "undefined" || $scope.$storage.shoppingCart.number == null || $scope.$storage.shoppingCart.number.trim() === "") {
                            $scope.suggestSalesOrderNumber();
                        }
                    });
                $scope.loadCountries();
                $scope.loadRetailers();
                $scope.loadCountries();
                $scope.loadOrderTypes();
            }
        ]);
})();